module.exports = __webpack_public_path__ + "resources/img/bg_signup_step.123199c19d93efa9651a4bc4c092b3e4.png";